import {
    Component, OnInit, Input, Output, EventEmitter,
    OnDestroy, ChangeDetectorRef
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserManagementService } from "../../services/user-management.service";
import { DataService } from "../../services/data.service";
import { FrontEndService } from "../../services/front-end.service";
import { StateService, Transition } from '@uirouter/angular';
import { Location } from '@angular/common';
import { ProjectManagementService } from 'app/services/project-management.service';
import { ChatService } from "app/services/chat.service";
import { LogService } from 'app/services/log.service';
import { Observable } from "rxjs/Rx";
import { ModalDismissReasons, NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CreateWallPostComponent } from "../create-wall-post/create-wall-post.component";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit, OnDestroy {

    @Input() projectList;
    @Input() currentState: string;
    @Output() updateActivity = new EventEmitter();
    @Output() getEvaluations = new EventEmitter();

    public modalRef: NgbModalRef;

    user_id: any;
    name: string;
    email: string;
    title: string;
    is_active: boolean;
    show_on_login = true;
    selectedLang = "en";
    currentUserProfile: any;
    all_user_profile = [];

    // Project list variable
    projectListData = this.dataService.project_list.filter(x => x['isActive'] === true);

    status = "IP";
    search_string = "";

    // Timer every 5 secs.
    timer = Observable.timer(0, 30000);
    timer_subscription: any;
    loading = false;
    firstProjectLoaded = false;
    project_details_flag = false;
    isProjectFetched = false;

    current_state_home = false;

    project_filter_list = this.dataService.project_list.filter(x => x['isActive'] === true);
    active_wall_post = [];

    constructor(
        private translate: TranslateService,
        public front_end_service: FrontEndService,
        public chatService: ChatService,
        public dataService: DataService,
        private location: Location,
        private user_management_service: UserManagementService,
        private stateService: StateService,
        private transition: Transition,
        private project_service: ProjectManagementService,
        private logService: LogService,
        private cdr: ChangeDetectorRef,
        private modalService: NgbModal
    ) {
    }

    ngOnInit() {
        if (localStorage.getItem('selectedLang')) {
            this.selectedLang = localStorage.getItem('selectedLang');
        }

        this.changeLang(this.selectedLang, false);

        if (!this.dataService.isLoggedIn && this.currentState !== 'forgotPassword') {
            this.show_on_login = false;
            this.stateService.go('login');
        } else {

            this.dataService.getModulePermissions(() => {
                this.set_headers();

                this.set_online_status();

                // Redirect from home to appropriate module
                if (this.dataService.projectModuleEnabled && this.currentState === "home" && (this.transition.params().project_id === "" ||  this.transition.params().project_id === undefined)) {
                    this.stateService.go("projectHome");
                } else if (!this.dataService.projectModuleEnabled && this.currentState === "home") {
                    if (this.dataService.workspaceEnabled) {
                        this.stateService.go("tasks");
                    } else {
                        this.stateService.go("Forbidden");
                    }
                } else if (
                    !this.dataService.projectModuleEnabled &&
                    (
                        this.currentState === "projectHome" ||
                        this.currentState === "project" ||
                        this.currentState === "projectUsers" ||
                        this.currentState === "projectAttachments" ||
                        this.currentState === "projectDetails" ||
                        this.stateService.current.name === "projectEvaluationTab" ||
                        this.currentState === "singlePost" ||
                        this.currentState === "projectEvaluation" ||
                        this.currentState === "createProject" ||
                        this.currentState === "editProject"
                    )
                ) {
                    this.stateService.go("Forbidden");
                } else if (
                    !this.dataService.evaluationModuleEnabled &&
                    (
                        this.stateService.current.name === "projectEvaluationTab" ||
                        this.stateService.current.name === "projectEvaluation"
                    )
                ) {
                    this.stateService.go("Forbidden");
                } else if (
                    !this.dataService.chatModuleEnabled &&
                    (
                        this.stateService.current.name === "projectChats"
                    )
                ) {
                    this.stateService.go("Forbidden");
                } else if (
                    !this.dataService.workspaceEnabled &&
                    (
                        this.currentState === "tasks" ||
                        this.currentState === "dashboard" ||
                        this.currentState === "modifyColumns"
                    )
                ) {
                    this.stateService.go("Forbidden");
                } else if (
                    !this.dataService.userProfileModuleEnabled &&
                    (
                        this.currentState === "profileList" ||
                        this.currentState === "profileDetails" ||
                        this.currentState === "createProfile" ||
                        this.currentState === "editProfile"
                    )
                ) {
                    this.stateService.go("Forbidden");
                } else if (
                    this.currentState === "login" ||
                    this.currentState === "signup" ||
                    this.currentState === "notFound" ||
                    this.currentState === "forgotPassword" ||
                    this.currentState === "forbidden"
                ) {
                    this.show_on_login = false;
                } else {
                    this.get_current_user_profile();

                    if (!this.currentUserProfile) {
                        this.currentUserProfile = this.dataService.currentUser;
                    }

                    this.check_user_access();
                    this.set_user_role_options();

                    if(this.show_on_login && this.dataService.projectModuleEnabled) {
                        this.timer_subscription = this.timer.subscribe(() => {
                            this.get_projects();
                            this.get_draft_comments();
                        });
                    }
                }
            });
        }
    }

    get_draft_comments() {
        this.active_wall_post = [];
        for (const key in localStorage) {
            if (key.startsWith("wall_draft_this_")) {
                const temp_obj = JSON.parse(localStorage.getItem(key));
                const key_mod = key.slice(16);
                const key_arr = key_mod.split("_");
                if (key_arr.length === 3 ) {
                    temp_obj["wall_reply_id"] = parseInt(key_arr[2], 10);
                }
                if (key_arr.length === 2 || key_arr.length === 3 ) {
                    temp_obj["wall_post_id"] = parseInt(key_arr[1], 10);
                }
                temp_obj["fip_id"] = parseInt(key_arr[0], 10);
                this.active_wall_post.push(temp_obj);
            }
        }
    }

    set_headers() {
        this.front_end_service.show_header = !(this.currentState === "createProject" || this.currentState === "editProject");
    }

    set_online_status() {
        if (localStorage.getItem('currentUser')) {

            if (!localStorage.getItem('onlineStatus')) {
                localStorage.setItem('onlineStatus', "false");
                this.front_end_service.isOnline = false;
            }

            if (localStorage.getItem('onlineStatus') === 'false') {
                localStorage.setItem('onlineStatus', "false");
                this.front_end_service.isOnline = false;
            } else {
                localStorage.setItem('onlineStatus', "false");
                this.front_end_service.isOnline = true;
            }

        }
    }

    get_current_user_profile() {
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.user_id = currentUser['id'];
        this.user_management_service.getUserProfile(this.user_id, (response) => {
            if (response.status === true) {
                const userDetails = response['data'];
                this.dataService.setCurrentUserDetails(userDetails);

                // Don't allow these pages if user is not admin
                if (
                    (
                        this.currentState === "userManagement" ||
                        this.currentState === "createUser" ||
                        this.currentState === "editUser" ||
                        this.currentState === "modifyColumns"
                    ) &&
                    (+this.currentUserProfile['role'] === 2 || +this.currentUserProfile['role'] === 3)
                ) {
                    this.stateService.go("Forbidden");
                }

                if(this.currentState === "evaluation" && +this.currentUserProfile['role'] === 2) {
                    this.stateService.go("Forbidden");
                }

                // Don't allow these pages if user is not Super Admin
                if ((this.currentState === "viewFeedback" || this.currentState === "backup") && this.currentUserProfile['role'] > 0) {
                    this.stateService.go("Forbidden");
                }
            }
        });

        this.user_management_service.userList((resp) => {
            this.all_user_profile = resp.data;

        });
    }

    check_user_access() {
        if (
            (this.currentState === "userManagement" || this.currentState === "createUser" || this.currentState === "editUser") &&
            (+this.currentUserProfile['role'] === 2 || +this.currentUserProfile['role'] === 3)
        ) {
            this.stateService.go("Forbidden");
        }

        if (this.currentState === "evaluation" && +this.currentUserProfile['role'] === 2) {
            this.stateService.go("Forbidden");
        }
    }

    set_user_role_options() {
        if (this.dataService.currentUser != null || this.dataService.currentUser !== undefined) {
            // Update user roles as per the profile
            if (+this.dataService.currentUser['role'] !== 0 && +this.dataService.currentUser['role'] !== 4) {

                this.dataService.userRoles = [
                    {
                        id: '2',
                        text: 'Researcher'
                    },
                    {
                        id: '3',
                        text: 'IPR/Technical Engineer/Legal Counsel'
                    }
                ];
            } else if (+this.dataService.currentUser['role'] === 4) {

                this.dataService.userRoles= [
                    {
                        id: '3',
                        text: 'IPR/Technical Engineer/Legal Counsel'
                    },
                    {
                        id: '4',
                        text: 'Customer Admin'
                    }
                ];
            }
        }
    }

    ngOnDestroy() {
        if(this.dataService.isLoggedIn && this.show_on_login && this.dataService.projectModuleEnabled && this.timer_subscription) {
            this.timer_subscription.unsubscribe();
        }
    }

    get_user_name(user_id) {
        let name = "";

        const user_profile = this.dataService.get_array_details(
            this.all_user_profile,
            "id",
            user_id
        );

        if (user_profile) {
            name = user_profile.title + " " + user_profile.name;
        }
        return name
    }

    toggleSidebar() {
        document.querySelector('.collapse').classList.toggle('show');
    }

    onLoggedOut() {
        this.logService.printLog('Logout called');
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('current_user');
        localStorage.clear();

        this.stateService.go('login');
        location.reload();
    }

    changeLang(language: string, clicked) {
        this.translate.use(language);
        localStorage.setItem('selectedLang', language);
        this.front_end_service.getTranslateJsonFile(language, () => {
            if (clicked) {
                // localStorage.setItem('selectedLang', language);
                const data = { "lang": language };
                if (localStorage.getItem('currentUserProfile')) {
                    this.currentUserProfile = JSON.parse(localStorage.getItem('currentUser'));

                    this.logService.printLog("userid1" + this.currentUserProfile['id']);
                    this.user_management_service.postLanguagePreference(this.currentUserProfile['id'], data, (resp) => {
                        if (resp.status) {
                            this.logService.printLog("callbackLanguage" + JSON.stringify(resp));
                        }
                    });
                }
            }

            this.dataService.enJson = language === 'en';

            while (this.dataService.project_search_status.length > 0) {
                this.dataService.project_search_status.pop();
            }
            this.dataService.project_search_status.push(
                {
                    id: 'All',
                    text: this.front_end_service.en_json_data['search_all']
                },
                {
                    id: 'CO',
                    text: this.front_end_service.en_json_data['search_closed']
                },
                {
                    id: 'IP',
                    text: this.front_end_service.en_json_data['search_inprogress']
                },
                {
                    id: 'OH',
                    text: this.front_end_service.en_json_data['search_onhold']
                },
                {
                    id: 'Archived',
                    text: this.front_end_service.en_json_data['search_archived']
                }
            );
            this.status = "IP";

            this.dataService.project_status = [
                {
                    id: 'CO',
                    text: this.front_end_service.en_json_data['search_closed']
                },
                {
                    id: 'IP',
                    text: this.front_end_service.en_json_data['search_inprogress']
                },
                {
                    id: 'OH',
                    text: this.front_end_service.en_json_data['search_onhold']
                }
            ];

            this.dataService.feedBackProjectStatus = [
                {
                    id: '0',
                    text: this.front_end_service.en_json_data['open']
                },
                {
                    id: '1',
                    text: this.front_end_service.en_json_data['IP']
                },
                {
                    id: '2',
                    text: this.front_end_service.en_json_data['resolved']
                },
                {
                    id: '3',
                    text: this.front_end_service.en_json_data['un_resolved']
                }
            ];
        });
    }

    export_project($event) {
        this.loading = true;
        this.project_service.export_project((resp) => {
            this.loading = false;
        });
    }

    goOnline() {
        setTimeout(() => {
            this.chatService.go_online();
        }, 400);
    }

    goToHome() {
        if(this.stateService.current.name !== 'login') {
            this.stateService.go('home');
        }
    }

    /**
     * Project list functionality
     * @param e
     * @param state
     */
    project_searched(e, state = false) {
        if (this.search_string.trim() === '') {
            this.projectListData = this.project_filter_list;
        } else {
            this.projectListData = this.project_filter_list.filter(
                (x) => {
                    for (const key in x) {
                        // look for the entry with a matching `code` value in arrays of objects
                        // in technical expert, patent engineer , researcher, reviewer and returning concern parent object
                        let arrayToSearchIn = null;
                        if(key === 'technical_expert' && x['technical_expert'].length !== 0) {
                            arrayToSearchIn ="technical_expert";
                        }
                        if(key === 'researcher' && x['researcher'].length !== 0) {
                            arrayToSearchIn ="researcher";
                        }
                        if(key === 'reviewer' && x['reviewer'].length !== 0) {
                            arrayToSearchIn ="reviewer";
                        }
                        if(key === 'patent_engineer' && x['patent_engineer'].length !== 0) {
                            arrayToSearchIn ="patent_engineer";
                        }
                        if(key === 'legal_counsel' && x['legal_counsel'].length !== 0) {
                            arrayToSearchIn ="legal_counsel";
                        }

                        if (arrayToSearchIn) {
                            for (let z = 0; z < x[arrayToSearchIn].length; z++) {
                                for (const key2 in x[arrayToSearchIn][z]) {
                                    // look for the entry with a matching `code` value

                                    if (x[arrayToSearchIn][z][key2] !== undefined && x[arrayToSearchIn][z][key2] !== null) {

                                        if (x[arrayToSearchIn][z][key2].toString().toLowerCase().search(this.dataService.escapeRegExp(this.search_string.toString().toLowerCase())) !== -1) {
                                            this.logService.printLog("x" + x);
                                            return x;
                                        }
                                    }
                                }
                            }
                        }
                        if(key === 'owner') {
                            arrayToSearchIn = "owner";
                            for (const key2 in x[arrayToSearchIn]) {
                                // look for the entry with a matching `code` value

                                if (x[arrayToSearchIn][key2] !== undefined && x[arrayToSearchIn][key2] !== null) {
                                    if (x[arrayToSearchIn][key2].toString().toLowerCase().search(this.dataService.escapeRegExp(this.search_string.toString().toLowerCase())) !== -1) {
                                        this.logService.printLog("x" + x);
                                        return x
                                    }
                                }
                            }
                        }
                        if (x.hasOwnProperty(key) && x[key] !== undefined && x[key] !== null) {
                            if (x[key].toString().toLowerCase().search(this.dataService.escapeRegExp(this.search_string.toString().toLowerCase())) !== -1) {
                                return x
                            }
                        }
                    }
                }
            );
            this.logService.printLog("this.projectListData" + JSON.stringify(this.projectListData))
        }
        if (state) {
            this.onSelection();
        }
    }

    onSelection(state = false) {
        let filterList = this.projectListData;

        if (this.status === 'All') {
            filterList = this.dataService.project_list.filter(x => x['isActive'] === true);
        } else if (this.status === 'CO') {
            filterList = this.dataService.project_list.filter(x => x['status'] === 'CO').filter(x => x['isActive'] === true);
        } else if (this.status === 'OH') {
            filterList = this.dataService.project_list.filter(x => x['status'] === 'OH').filter(x => x['isActive'] === true);
        } else if (this.status === 'IP') {
            filterList = this.dataService.project_list.filter(x => x['status'] === 'IP').filter(x => x['isActive'] === true);
        } else if (this.status === 'AR') {
            filterList = this.dataService.project_list.filter(x => x['status'] === 'AR').filter(x => x['isActive'] === true);
        } else if (this.status === 'Archived') {
            filterList = this.dataService.project_list.filter(x => x['isActive'] === false);
        }

        this.project_filter_list = this.projectListData = filterList;

        if(state) {
            this.project_searched({});
        }
    }

    filter_projects(e, state = false) {
        if(state) {
            this.status = e.value;
            this.loading = true;
            this.project_details_flag = false;
            this.firstProjectLoaded = false;

            this.get_projects();
        }

        this.onSelection(true);
    }

    get_projects() {
        if (this.dataService.project_get_waiting_for_response) {
            // Stop further http requests until last req. gives ans/
            this.logService.printLog("get projects waiting for response.");
        } else {

            this.dataService.project_get_waiting_for_response = true;

            if (!this.firstProjectLoaded) {
                this.loading = true;
            }

            let project_type = null;
            if (this.currentState === 'projectHome') {
                if (this.status === "Archived" || this.status === "AR") {
                    project_type = "archive";
                } else {
                    project_type = this.status.toLowerCase();
                }
            }

            this.project_service.get_projects((resp) => {
                this.loading = false;
                this.project_details_flag = true;

                this.dataService.project_get_waiting_for_response = false;

                if (resp.status === true) {

                    /*
                       Calling project detail view
                    */
                    if (resp.data.length === 0) {
                        this.firstProjectLoaded = true;
                        this.isProjectFetched = true;
                    }

                    let projectAllowed = false;
                    for (let i = 0; i < resp.data.length; i++) {
                        const test_proj = this.dataService.get_array_details(this.dataService.project_list, "fip_id", resp.data[i].fip_id);

                        let get_details = false;

                        if (test_proj !== undefined) {
                            if (test_proj.last_modified !== resp.data[i].last_modified) {
                                for (const key in resp.data[i]) {
                                    if (key !== 'project_type') {
                                        test_proj[key] = resp.data[i][key];
                                    }
                                }
                                projectAllowed = true;
                                this.dataService.projectListObservable.next();
                            } else {
                                get_details = true;
                            }
                        } else {
                            get_details = true;
                        }

                        this.dataService.projectTypes.forEach((projectType) => {
                            if (projectType.id === resp.data[i]['project_type']) {
                                resp.data[i]['project_type_text'] = projectType.text;
                            }
                        });

                        if (get_details) {
                            // Fetch only required projects here
                            if (!this.current_state_home) {
                                get_details = false;
                                if (this.dataService.selected_project === resp.data[i].fip_id) {
                                    get_details = true;
                                }
                            }

                            // Get current state projects' details only
                            if (get_details) {
                                projectAllowed = true;
                                this.get_project_details(resp.data[i].fip_id);
                            }
                        }
                    }

                    // Go to forbidden if a project is opened and user does not have access
                    if (!projectAllowed && this.currentState !== 'projectHome' && this.dataService.selected_project) {
                        this.stateService.go("Forbidden");
                    }

                    // Remove any project which have been deleted or user access has been revoked
                    if (this.dataService.project_list.length !== resp.data.length) {
                        this.dataService.project_list.forEach((project, index) => {
                            const deletedProject = this.dataService.get_array_details(resp.data, "fip_id", project.fip_id);
                            if (deletedProject === undefined) {
                                this.dataService.project_list.splice(index, 1);
                            }
                        });
                        this.filter_projects({});
                    }

                    this.dataService.unreadNotification = 0;
                    for (let u = 0; u < resp.data.length; u++) {
                        this.dataService.unreadNotification += parseInt(resp.data[u].unread_count);
                    }
                } else {
                    this.logService.printLog("Failed Projects controller callback");
                }
            }, project_type);
        }
    }

    get_project_details(project_id) {
        this.project_service.get_project_details(
            project_id, (resp) => {

                if (resp.status === true) {

                    this.firstProjectLoaded = true;

                    const test_proj = this.dataService.get_array_details(this.dataService.project_list, "fip_id", resp.data.fip_id);

                    if (test_proj !== undefined) {
                        for (const key in resp.data) {
                            test_proj[key] = resp.data[key];
                        }
                    } else {
                        this.dataService.project_list.push(resp.data);
                        this.isProjectFetched = true;
                    }

                    // sort array
                    this.dataService.project_list = this.dataService.sort_this_by_date(
                        this.dataService.project_list,
                        "required_delivery_date"
                    );

                    this.dataService.projectListObservable.next();

                    // Add chatting rooms
                    if (this.dataService.chatModuleEnabled) {
                        this.chatService.createRoomsList();
                    }

                    this.filter_projects({});

                } else {
                    this.logService.printLog("Failed Project Details controller callback");
                }
            }
        );
    }

    thisProjectActivityUpdateAndGetEvaluation() {
        this.dataService.current_project_changed = true;

        this.updateActivity.emit(null);
        this.getEvaluations.emit(null);
    }

    open_draft_editor(wall_post) {
        if (wall_post.hasOwnProperty('wall_post_id')) {
            // This is for nested reply.
            this.modalRef = this.modalService.open(CreateWallPostComponent, { windowClass: "create-post-modal" });
            this.modalRef.componentInstance.wallReplyId = wall_post["wall_reply_id"];
            this.modalRef.componentInstance.wallPostId = wall_post["wall_post_id"];
            this.modalRef.componentInstance.projectId = wall_post["fip_id"];
            this.modalRef.componentInstance.indexNo = wall_post["indexNo"];
            this.modalRef.componentInstance.modalRef = this.modalRef;
            this.modalRef.result.then((result) => {
                const closeResult = `Closed with: ${result}`;
            }, (reason) => {
                const closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            });

            this.stateService.go("singlePost", { project_id: wall_post.fip_id, post_id: wall_post["wall_post_id"] });
        } else {
            // this is for 1st level reply only.
            this.stateService.go("project", { project_id: wall_post.fip_id });
        }
    }

    /**
     * Get dismiss reason for modal
     * @param reason
     * @returns {string}
     */
    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
}
